import React, { Component } from 'react';
import SubActions from '.';
import SubActionButton from './SubActionButton';
import ExpireAttSubModal from 'components/modals/ExpireSubModal/att';
import UpdateAttDeviceModal from 'components/modals/UpdateDeviceModal/att';
import AttActivateModal from 'components/modals/ActivateModal/att';
import SuspendAttSubModal from 'components/modals/SuspendSubModal/att';
import RestoreAttSubModal from 'components/modals/RestoreSubModal/att';
import SetAttUpcomingPlanModal from 'components/modals/SetUpcomingPlanModal/att';
import SetAttPlanModal from 'components/modals/SetPlanModal/att';
import UpgradeAttPlanModal from 'components/modals/UpgradePlanModal/att';
import AddAttLeaseModal from 'components/modals/AddLeaseModal/att';
import { can, permActions } from 'permissions';

const {
  SET_ATT_UPCOMING_PLAN,
  SET_ATT_PLAN,
  UPGRADE_ATT_INVOICE,
  EXPIRE_ATT_SUB,
  UPDATE_ATT_DEVICE,
  ACTIVATE_ATT_SUB,
  SUSPEND_ATT_SUB,
  RESTORE_ATT_SUB,
  ADD_ATT_LEASE,
} = permActions;

class AttSubActions extends Component {
  state = {
    opennedModal: '',
  };

  setOpennedModal = (modal) => this.setState({ opennedModal: modal });
  closeModal = () => this.setState({ opennedModal: '' });

  render() {
    const { sub, user, loggedInUser } = this.props;
    const { opennedModal } = this.state;

    const isExpired = sub?.att_status === 'expired';
    const isNew = sub?.att_status === 'new';
    const isSuspended = sub?.att_status === 'suspended';
    const isActive = sub?.att_status === 'active';

    const showUpdateDevice = !isExpired && can(loggedInUser, UPDATE_ATT_DEVICE);
    const showSetUpcomingPlan =
      !isNew && !isExpired && can(loggedInUser, SET_ATT_UPCOMING_PLAN);
    const showSetPlan = !isExpired && can(loggedInUser, SET_ATT_PLAN);
    const showUpgradeInvoice =
      !isNew && !isExpired && can(loggedInUser, UPGRADE_ATT_INVOICE);
    const showActivate =
      ['new', 'port_confirmed', 'port_completed', 'rejected'].includes(
        sub?.att_status,
      ) && can(loggedInUser, ACTIVATE_ATT_SUB);
    const showExpire =
      !isExpired && !isNew && can(loggedInUser, EXPIRE_ATT_SUB);
    const showSuspend =
      isActive && can(loggedInUser, SUSPEND_ATT_SUB, { sub, loggedInUser });
    const showRestore =
      isSuspended && can(loggedInUser, RESTORE_ATT_SUB, { sub, loggedInUser });
    const showAddLease = !isExpired && can(loggedInUser, ADD_ATT_LEASE);

    const buttons = [
      {
        id: UPDATE_ATT_DEVICE,
        iconPath: '/images/icons/subActions/device-icon.svg',
        text: 'Update Device',
        onClick: this.setOpennedModal,
        isShown: showUpdateDevice,
      },
      {
        id: SET_ATT_PLAN,
        iconPath: '',
        text: 'Update Plan',
        onClick: this.setOpennedModal,
        isShown: showSetPlan,
      },
      {
        id: SET_ATT_UPCOMING_PLAN,
        iconPath: '',
        text: 'Upcoming Plan',
        onClick: this.setOpennedModal,
        isShown: showSetUpcomingPlan,
      },
      {
        id: UPGRADE_ATT_INVOICE,
        iconPath: '',
        text: 'Plan Upgrade',
        onClick: this.setOpennedModal,
        isShown: showUpgradeInvoice,
      },
      {
        id: ACTIVATE_ATT_SUB,
        iconPath: '/images/icons/subActions/user-icon.svg',
        text: 'Activate Sub',
        onClick: this.setOpennedModal,
        isShown: showActivate,
      },
      {
        id: SUSPEND_ATT_SUB,
        iconPath: '/images/icons/subActions/pause-icon.svg',
        text: 'Suspend Sub',
        onClick: this.setOpennedModal,
        isShown: showSuspend,
      },
      {
        id: RESTORE_ATT_SUB,
        iconPath: '/images/icons/subActions/play-icon.svg',
        text: 'Restore Sub',
        onClick: this.setOpennedModal,
        isShown: showRestore,
      },
      {
        id: EXPIRE_ATT_SUB,
        iconPath: '/images/icons/subActions/cross-icon.svg',
        text: 'Expire Sub',
        onClick: this.setOpennedModal,
        isShown: showExpire,
      },
      {
        id: ADD_ATT_LEASE,
        iconPath: '',
        text: 'Add Lease',
        onClick: this.setOpennedModal,
        isShown: showAddLease,
      },
    ];

    return (
      <SubActions>
        {buttons.map((button) => (
          <SubActionButton key={button.id} {...button} />
        ))}
        <UpdateAttDeviceModal
          sub={sub}
          isOpen={opennedModal === UPDATE_ATT_DEVICE}
          closeModal={this.closeModal}
        />
        <AttActivateModal
          sub={sub}
          isOpen={opennedModal === ACTIVATE_ATT_SUB}
          closeModal={this.closeModal}
        />
        <SuspendAttSubModal
          sub={sub}
          isOpen={opennedModal === SUSPEND_ATT_SUB}
          closeModal={this.closeModal}
        />
        <RestoreAttSubModal
          sub={sub}
          isOpen={opennedModal === RESTORE_ATT_SUB}
          closeModal={this.closeModal}
        />
        <ExpireAttSubModal
          sub={sub}
          isOpen={opennedModal === EXPIRE_ATT_SUB}
          closeModal={this.closeModal}
        />
        <SetAttUpcomingPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === SET_ATT_UPCOMING_PLAN}
          closeModal={this.closeModal}
        />
        <SetAttPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === SET_ATT_PLAN}
          closeModal={this.closeModal}
        />
        <UpgradeAttPlanModal
          sub={sub}
          subId={sub?.id}
          user={user}
          isOpen={opennedModal === UPGRADE_ATT_INVOICE}
          closeModal={this.closeModal}
        />
        <AddAttLeaseModal
          sub={sub}
          subId={sub?.id}
          isOpen={opennedModal === ADD_ATT_LEASE}
          closeModal={this.closeModal}
        />
      </SubActions>
    );
  }
}

export default AttSubActions;
